import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import AppRoutes from './components/Routes';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
